import { useBpAdminFeeChargeCodeEnabled } from '../feature-flags/useBpAdminFeeChargeCodeEnabled';
import { priceInputToComponents } from 'lane-shared/domains/billingPayments/helpers/priceInputToComponents';
import { PriceInput } from 'application-types';
import { getPricing, type Pricing } from 'domains-billing-calculation';
import { SupportedPaymentCurrency } from 'domains-billing-currency';
import { SupportedLocaleEnum } from 'localization';

export type UseProductPricingParams = {
  priceInput: PriceInput;
  currency: SupportedPaymentCurrency;
  locale: SupportedLocaleEnum;
  inclusivePricing?: boolean;
};

export function useProductPricing({
  priceInput,
  currency,
  locale,
  inclusivePricing = false,
}: UseProductPricingParams): Pricing {
  const isBpAdminFeeChargeCodeEnabled = useBpAdminFeeChargeCodeEnabled();
  const priceComponents = priceInputToComponents(priceInput);

  return getPricing({
    currency,
    locale,
    priceComponents,
    inclusivePricing,
    isAdminFeeFeatureEnabled: isBpAdminFeeChargeCodeEnabled,
  });
}
